import { EVENT_TYPE } from "../../AnalyticsTracking/events";
import { emitEvent } from "../../Shared/Assets/src/tagmanager";

document.querySelectorAll<HTMLElement>("[data-campaign-form]")?.forEach(campaignForm => {
  const form = campaignForm.querySelector<HTMLFormElement>("form");

  if (form) {
    form.addEventListener("submit", () =>
      emitEvent(
        EVENT_TYPE.campaignFormSubmitted,
        { campaignCode: campaignForm.dataset.campaignCode },
        false
      )
    );
  }
});
